import { render, staticRenderFns } from "./TabLaboratorio.vue?vue&type=template&id=5c802d4e&"
import script from "./TabLaboratorio.vue?vue&type=script&lang=js&"
export * from "./TabLaboratorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports